// src/i18n/index.js
import { createI18n } from 'vue-i18n';

// Importaciones en inglés
import menuEN from './locales/en/menu.json';
import homeEN from './locales/en/home.json';
import trick_listEN from './locales/en/trick_list.json';
import rulesEN from './locales/en/rules.json';
import judging_programEN from './locales/en/judging_program.json';
import profileEN from './locales/en/profile.json';
import authEN from './locales/en/auth.json';
import modeEN from './locales/en/mode.json';
import competitionsEN from './locales/en/competitions.json';
import athletesEN from './locales/en/athletes.json';
import roundsEN from './locales/en/rounds.json';
import judgeEN from './locales/en/judge.json';
import judgesEN from './locales/en/judges.json';
import organizersEN from './locales/en/organizers.json';
import trainingEN from './locales/en/training.json';
import sessionEN from './locales/en/session.json';
import notificationsEN from './locales/en/notifications.json';
import commonEN from './locales/en/common.json';
import managementEN from './locales/en/management.json';
import privacyPolicyEN from './locales/en/privacy_policy.json';
import cookiesPolicyEN from './locales/en/cookies_policy.json';
import termsConditionsEN from './locales/en/terms_conditions.json';

// Español
import menuES from './locales/es/menu.json';
import homeES from './locales/es/home.json';
import trick_listES from './locales/es/trick_list.json';
import rulesES from './locales/es/rules.json';
import judging_programES from './locales/es/judging_program.json';
import profileES from './locales/es/profile.json';
import authES from './locales/es/auth.json';
import modeES from './locales/es/mode.json';
import competitionsES from './locales/es/competitions.json';
import athletesES from './locales/es/athletes.json';
import roundsES from './locales/es/rounds.json';
import judgeES from './locales/es/judge.json';
import judgesES from './locales/es/judges.json';
import organizersES from './locales/es/organizers.json';
import trainingES from './locales/es/training.json';
import sessionES from './locales/es/session.json';
import notificationsES from './locales/es/notifications.json';
import commonES from './locales/es/common.json';
import managementES from './locales/es/management.json';
import privacyPolicyES from './locales/es/privacy_policy.json';
import cookiesPolicyES from './locales/es/cookies_policy.json';
import termsConditionsES from './locales/es/terms_conditions.json';

// Italiano
import notificationsIT from './locales/it/notifications.json';
import commonIT from './locales/it/common.json';
import privacyPolicyIT from './locales/it/privacy_policy.json';
import cookiesPolicyIT from './locales/it/cookies_policy.json';
import termsConditionsIT from './locales/it/terms_conditions.json';

// Italiano
import menuIT from './locales/it/menu.json';
import homeIT from './locales/it/home.json';
import trick_listIT from './locales/it/trick_list.json';
import rulesIT from './locales/it/rules.json';
import judging_programIT from './locales/it/judging_program.json';
import profileIT from './locales/it/profile.json';
import authIT from './locales/it/auth.json';
import modeIT from './locales/it/mode.json';
import competitionsIT from './locales/it/competitions.json';
import athletesIT from './locales/it/athletes.json';
import roundsIT from './locales/it/rounds.json';
import judgeIT from './locales/it/judge.json';
import judgesIT from './locales/it/judges.json';
import organizersIT from './locales/it/organizers.json';
import trainingIT from './locales/it/training.json';
import sessionIT from './locales/it/session.json';
import managementIT from './locales/it/management.json';

// Francés
import menuFR from './locales/fr/menu.json';
import homeFR from './locales/fr/home.json';
import trick_listFR from './locales/fr/trick_list.json';
import rulesFR from './locales/fr/rules.json';
import judging_programFR from './locales/fr/judging_program.json';
import profileFR from './locales/fr/profile.json';
import authFR from './locales/fr/auth.json';
import modeFR from './locales/fr/mode.json';
import competitionsFR from './locales/fr/competitions.json';
import athletesFR from './locales/fr/athletes.json';
import roundsFR from './locales/fr/rounds.json';
import judgeFR from './locales/fr/judge.json';
import judgesFR from './locales/fr/judges.json';
import organizersFR from './locales/fr/organizers.json';
import trainingFR from './locales/fr/training.json';
import sessionFR from './locales/fr/session.json';
import notificationsFR from './locales/fr/notifications.json';
import commonFR from './locales/fr/common.json';
import managementFR from './locales/fr/management.json';
import privacyPolicyFR from './locales/fr/privacy_policy.json';
import cookiesPolicyFR from './locales/fr/cookies_policy.json';
import termsConditionsFR from './locales/fr/terms_conditions.json';

// Japonés
import menuJP from './locales/jp/menu.json';
import homeJP from './locales/jp/home.json';
import trick_listJP from './locales/jp/trick_list.json';
import rulesJP from './locales/jp/rules.json';
import judging_programJP from './locales/jp/judging_program.json';
import profileJP from './locales/jp/profile.json';
import authJP from './locales/jp/auth.json';
import modeJP from './locales/jp/mode.json';
import competitionsJP from './locales/jp/competitions.json';
import athletesJP from './locales/jp/athletes.json';
import roundsJP from './locales/jp/rounds.json';
import judgeJP from './locales/jp/judge.json';
import judgesJP from './locales/jp/judges.json';
import organizersJP from './locales/jp/organizers.json';
import trainingJP from './locales/jp/training.json';
import sessionJP from './locales/jp/session.json';
import notificationsJP from './locales/jp/notifications.json';
import commonJP from './locales/jp/common.json';
import managementJP from './locales/jp/management.json';
import privacyPolicyJP from './locales/jp/privacy_policy.json';
import cookiesPolicyJP from './locales/jp/cookies_policy.json';
import termsConditionsJP from './locales/jp/terms_conditions.json';

// Alemán
import menuDE from './locales/de/menu.json';
import homeDE from './locales/de/home.json';
import trick_listDE from './locales/de/trick_list.json';
import rulesDE from './locales/de/rules.json';
import judging_programDE from './locales/de/judging_program.json';
import profileDE from './locales/de/profile.json';
import authDE from './locales/de/auth.json';
import modeDE from './locales/de/mode.json';
import competitionsDE from './locales/de/competitions.json';
import athletesDE from './locales/de/athletes.json';
import roundsDE from './locales/de/rounds.json';
import judgeDE from './locales/de/judge.json';
import judgesDE from './locales/de/judges.json';
import organizersDE from './locales/de/organizers.json';
import trainingDE from './locales/de/training.json';
import sessionDE from './locales/de/session.json';
import notificationsDE from './locales/de/notifications.json';
import commonDE from './locales/de/common.json';
import managementDE from './locales/de/management.json';
import privacyPolicyDE from './locales/de/privacy_policy.json';
import cookiesPolicyDE from './locales/de/cookies_policy.json';
import termsConditionsDE from './locales/de/terms_conditions.json';

// Portugués
import menuPT from './locales/pt/menu.json';
import homePT from './locales/pt/home.json';
import trick_listPT from './locales/pt/trick_list.json';
import rulesPT from './locales/pt/rules.json';
import judging_programPT from './locales/pt/judging_program.json';
import profilePT from './locales/pt/profile.json';
import authPT from './locales/pt/auth.json';
import modePT from './locales/pt/mode.json';
import competitionsPT from './locales/pt/competitions.json';
import athletesPT from './locales/pt/athletes.json';
import roundsPT from './locales/pt/rounds.json';
import judgePT from './locales/pt/judge.json';
import judgesPT from './locales/pt/judges.json';
import organizersPT from './locales/pt/organizers.json';
import trainingPT from './locales/pt/training.json';
import sessionPT from './locales/pt/session.json';
import notificationsPT from './locales/pt/notifications.json';
import commonPT from './locales/pt/common.json';
import managementPT from './locales/pt/management.json';
import privacyPolicyPT from './locales/pt/privacy_policy.json';
import cookiesPolicyPT from './locales/pt/cookies_policy.json';
import termsConditionsPT from './locales/pt/terms_conditions.json';


const messages = {
    en: {
        auth: authEN,
        menu: menuEN,
        home: homeEN,
        trick_list: trick_listEN,
        rules: rulesEN,
        judging_program: judging_programEN,
        profile: profileEN,
        mode: modeEN,
        competitions: competitionsEN,
        athletes: athletesEN,
        rounds: roundsEN,
        judge: judgeEN,
        judges: judgesEN,
        organizers: organizersEN,
        training: trainingEN,
        session: sessionEN,
        notifications: notificationsEN,
        notification: notificationsEN.notification,
        common: commonEN,
        management: managementEN,
        privacy_policy: privacyPolicyEN,
        cookies_policy: cookiesPolicyEN,
        terms_conditions: termsConditionsEN,
    },
    es: {
        auth: authES,
        menu: menuES,
        home: homeES,
        trick_list: trick_listES,
        rules: rulesES,
        judging_program: judging_programES,
        profile: profileES,
        mode: modeES,
        competitions: competitionsES,
        athletes: athletesES,
        rounds: roundsES,
        judge: judgeES,
        judges: judgesES,
        organizers: organizersES,
        training: trainingES,
        session: sessionES,
        notifications: notificationsES,
        notification: notificationsES.notification,
        common: commonES,
        management: managementES,
        privacy_policy: privacyPolicyES,
        cookies_policy: cookiesPolicyES,
        terms_conditions: termsConditionsES,
    },
    it: {
        auth: authIT,
        menu: menuIT,
        home: homeIT,
        trick_list: trick_listIT,
        rules: rulesIT,
        judging_program: judging_programIT,
        profile: profileIT,
        mode: modeIT,
        competitions: competitionsIT,
        athletes: athletesIT,
        rounds: roundsIT,
        judge: judgeIT,
        judges: judgesIT,
        organizers: organizersIT,
        training: trainingIT,
        session: sessionIT,
        notifications: notificationsIT,
        notification: notificationsIT.notification,
        common: commonIT,
        management: managementIT,
        privacy_policy: privacyPolicyIT,
        cookies_policy: cookiesPolicyIT,
        terms_conditions: termsConditionsIT,
    },
    fr: {
        auth: authFR,
        menu: menuFR,
        home: homeFR,
        trick_list: trick_listFR,
        rules: rulesFR,
        judging_program: judging_programFR,
        profile: profileFR,
        mode: modeFR,
        competitions: competitionsFR,
        athletes: athletesFR,
        rounds: roundsFR,
        judge: judgeFR,
        judges: judgesFR,
        organizers: organizersFR,
        training: trainingFR,
        session: sessionFR,
        notifications: notificationsFR,
        notification: notificationsFR.notification,
        common: commonFR,
        management: managementFR,
        privacy_policy: privacyPolicyFR,
        cookies_policy: cookiesPolicyFR,
        terms_conditions: termsConditionsFR,
    },
    jp: {
        auth: authJP,
        menu: menuJP,
        home: homeJP,
        trick_list: trick_listJP,
        rules: rulesJP,
        judging_program: judging_programJP,
        profile: profileJP,
        mode: modeJP,
        competitions: competitionsJP,
        athletes: athletesJP,
        rounds: roundsJP,
        judge: judgeJP,
        judges: judgesJP,
        organizers: organizersJP,
        training: trainingJP,
        session: sessionJP,
        notifications: notificationsJP,
        notification: notificationsJP.notification,
        common: commonJP,
        management: managementJP,
        privacy_policy: privacyPolicyJP,
        cookies_policy: cookiesPolicyJP,
        terms_conditions: termsConditionsJP,
    },
    de: {
        auth: authDE,
        menu: menuDE,
        home: homeDE,
        trick_list: trick_listDE,
        rules: rulesDE,
        judging_program: judging_programDE,
        profile: profileDE,
        mode: modeDE,
        competitions: competitionsDE,
        athletes: athletesDE,
        rounds: roundsDE,
        judge: judgeDE,
        judges: judgesDE,
        organizers: organizersDE,
        training: trainingDE,
        session: sessionDE,
        notifications: notificationsDE,
        notification: notificationsDE.notification,
        common: commonDE,
        management: managementDE,
        privacy_policy: privacyPolicyDE,
        cookies_policy: cookiesPolicyDE,
        terms_conditions: termsConditionsDE,
    },
    pt: {
        auth: authPT,
        menu: menuPT,
        home: homePT,
        trick_list: trick_listPT,
        rules: rulesPT,
        judging_program: judging_programPT,
        profile: profilePT,
        mode: modePT,
        competitions: competitionsPT,
        athletes: athletesPT,
        rounds: roundsPT,
        judge: judgePT,
        judges: judgesPT,
        organizers: organizersPT,
        training: trainingPT,
        session: sessionPT,
        notifications: notificationsPT,
        notification: notificationsPT.notification,
        common: commonPT,
        management: managementPT,
        privacy_policy: privacyPolicyPT,
        cookies_policy: cookiesPolicyPT,
        terms_conditions: termsConditionsPT,
    }
};


const i18n = createI18n({
    locale: 'en', // Idioma predeterminado
    fallbackLocale: 'en',
    messages,
});

export default i18n;
